import { FormControl, MenuItem, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import { type FC } from 'react';

export interface ColumnHeaderFilterOption {
    value: string;
    label: string;
}

interface ColumnHeaderFilterProps {
    label: string;
    value: string;
    idleValue: string;
    options: ColumnHeaderFilterOption[];
    onChange: (value: string) => void;
}

const ColumnHeaderFilter: FC<ColumnHeaderFilterProps> = ({
    label,
    value,
    idleValue,
    options,
    onChange,
}) => {
    const active = value !== idleValue;
    const selectedLabel = options.find((option) => option.value === value)?.label;

    return (
        <FormControl variant="standard" size="small">
            <Select
                disableUnderline
                displayEmpty
                value={value}
                aria-label={label}
                onChange={(event: SelectChangeEvent) => onChange(event.target.value)}
                renderValue={() => (active && selectedLabel ? `${label}: ${selectedLabel}` : label)}
                sx={{
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: active ? 'primary.main' : 'inherit',
                    '& .MuiSelect-select': {
                        py: 0.25,
                        pr: '22px !important',
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option.value || 'all'} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ColumnHeaderFilter;
